import type { ID, ResourceStore } from "../lib/resource/type";
import { createResourceStore } from "@/lib/resource";
import type { Business } from "./Business";
import type { Asset } from "./Asset";

import { formatNumber } from "@/lib/utils";
import type { Location } from "./Location";
import { apiClient } from "@/lib/http";

export interface Shop {
  id: string;
  name: string;
  phone_number: string;
  email: string;
  address: string;
  business_id: string;
  business: Business;
  location_id: string;
  location?: Location;
  status: string;
  type: string;
  shop_type: string;
  shop_logo: string | null;
  contact_info: string;
  manager: string;
  logo: Asset;
  // Settings

  currency: string;
  language: string;
  timezone: string;

  tax_rate: number;
  invoice_prefix: string;
  receipt_prefix: string;
  receipt_format: string;
  low_stock_threshold: number;

  enable_stock_alerts: boolean;
  enable_customer_loyalty: boolean;

  points_per_purchase: number;
  money_per_point: number;

  operating_hours: string;

  order_prefix: string;
  date_format: string;
  time_format: string;
  receipt_message: string;
  //
  currentEmployee: string; // This value is use to know which employee is currently logged.
}

interface ShopStore extends ResourceStore<Shop> {
  getUserShops: (userId: string) => Promise<any>;
  saveCurrentShopId: (shop_id: ID) => void;
  getCurrentShopId: () => ID | undefined;
  selectShop: (shop: Shop) => void;
  selectShopById: (id: any) => void;
  formatAmount: (amount: number) => string;
}

export const useShop = createResourceStore<Shop, ShopStore>(
  "shops",
  (_set, get) => ({
    stats: {
      stock_batches_count: 0,
      products_count: 0,
    },

    getUserShops: (userId: string) => {
      return apiClient()
        .get(`/users/${userId}/shops`)
        .then((res) => {
          get().setItems(res.data);
          return Promise.resolve(res.data);
        });
    },

    async saveCurrentShopId(shop_id: ID) {
      localStorage.setItem("current_shop_id", shop_id as string);
    },

    getCurrentShopId() {
      const id = localStorage.getItem("current_shop_id");
      if (id) {
        return id;
      } else {
        return undefined;
      }
    },

    selectShop: (shop: Shop) => {
      get().setCurrent(shop);
      get().saveCurrentShopId(shop.id);
    },

    selectShopById: (id: ID) => {
      const shop = get().items.find((s: Shop) => s.id == id);
      if (shop) {
        get().selectShop(shop);
        get().saveCurrentShopId(id);
      }
    },

    formatAmount: (amount: number) => {
      return `${formatNumber(amount)} ${get().current?.currency}`;
    },
  })
);
